/* ============================================================================
   sf-bundle-set.js — STARKSHAKE Set-Baukasten (BND-01, 30.09.2026)
   Rendert Shaker-Farbe + Whey (Produkt, Sorte) aus dem JSON der Section, rechnet
   Einzel- und Setpreis und legt beides mit einem Klick in den Warenkorb.
   Element-API fuer den Protein-Rechner: purchasable, priceFor(handle), preselect(handle).
   30.09.2026: Modus "order" (Section-Einstellung preorder_mode) bestellt den Shaker als
   Vorbestellung und den PEAK-Whey sofort, siehe addPreorder().
   30.09.2026 abends: Summenkarte wie die Set-Karte des Protein-Rechners (Kacheln + Glas-Plus,
   Titel, Preis, Siegel, Button unten), Shaker-Vorteile aus <template data-sfbs-tpl="perks">.
   30.09.2026 spaet (Nayl: Summenkarte "immer noch nicht so geil"): alles in EINER Glas-Karte
   (die Buehne [data-sfbs-stage] ist die Karte), Summe als Spalte hinter einer Haarlinie in drei
   Gruppen (Kopf mit Kacheln, Siegel-Vorteile, Kaufblock) und Preis-Aufstellung "Einzeln / Im Set"
   direkt ueber dem Button. Warenkorb-Logik unveraendert.
   Feinschliff 30.09.2026 nachts: Summe als eine Gruppe (Kopf + Siegel) plus Kaufblock, Titel mit
   geschuetztem "STARKSHAKE V4 +", Umbruchschutz fuer Zahlen, Einheiten und Datumsangaben.
   ============================================================================ */
(function () {
  'use strict';
  if (typeof window === 'undefined' || !window.customElements || customElements.get('sf-bundle-set')) return;

  var el = function (tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text !== undefined && text !== null) e.textContent = text;
    return e;
  };
  var fill = function (tpl, map) {
    return String(tpl || '').replace(/\[(\w+)\]/g, function (m, k) {
      return Object.prototype.hasOwnProperty.call(map, k) ? map[k] : m;
    });
  };
  var uid = 0;

  /** Shopify-Geldformat mit den ueblichen Platzhaltern */
  function formatMoney(cents, format) {
    var fmt = format || '€{{amount_with_comma_separator}}';
    var n = Math.round(Number(cents) || 0);
    var num = function (dec, thou, sep) {
      var v = (n / 100).toFixed(dec).split('.');
      var whole = v[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return v[1] ? whole + sep + v[1] : whole;
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      if (key === 'amount') return num(2, ',', '.');
      if (key === 'amount_no_decimals') return num(0, ',', '.');
      if (key === 'amount_with_comma_separator') return num(2, '.', ',');
      if (key === 'amount_no_decimals_with_comma_separator') return num(0, '.', ',');
      if (key === 'amount_with_apostrophe_separator') return num(2, "'", '.');
      return num(2, '.', ',');
    });
  }

  /* ------------------------------------------------ Vorbestellung (Modus "order", 30.09.2026)
     Gleiche Regeln wie assets/stl-preorder-direct-cart.js (Map-Pruefung, Produktabgleich, Zeilen-
     eigenschaften, Versandfenster-Text) und die Checkout-Validierung preorder-separate-order. */
  var PEAK_VENDOR = 'PEAK Performance Products S.A.';
  var MONTHS = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];

  // Wortgleich mit stl-preorder-direct-cart.js: der Checkout vergleicht diesen Text mit stl.shipping_window.
  function readableShippingWindow(value) {
    const match = value.match(/^(\d{4})-(\d{2})-(\d{2}) – (\d{4})-(\d{2})-(\d{2})$/);
    if (!match) return value;
    const months = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];
    const format = (year, month, day) => `${Number(day)}. ${months[Number(month) - 1]} ${year}`;
    if (![match[2], match[5]].every(month => Number(month) >= 1 && Number(month) <= 12)
      || ![match[3], match[6]].every(day => Number(day) >= 1 && Number(day) <= 31)) return value;
    const start = format(match[1], match[2], match[3]);
    const end = format(match[4], match[5], match[6]);
    return start === end ? `Voraussichtlich ab ${start}` : `Voraussichtlich ${start} – ${end}`;
  }
  /** Erster Tag des Versandfensters als "19. Oktober 2026" (wie snippets/stl-preorder-cart-line.liquid) */
  function shipFrom(value) {
    var m = String(value || '').match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (!m || Number(m[2]) < 1 || Number(m[2]) > 12 || Number(m[3]) < 1 || Number(m[3]) > 31) return '';
    return Number(m[3]) + '. ' + MONTHS[Number(m[2]) - 1] + ' ' + m[1];
  }
  function digits(value) { return /^[1-9][0-9]*$/.test(String(value || '')); }
  function localeRoot() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return typeof root === 'string' && /^\/(?:[a-zA-Z-]+\/)*$/.test(root) ? root : '/';
  }
  function validMap(map) {
    return Boolean(map && map.version === 1 && typeof map.productId === 'string' && digits(map.productId)
      && typeof map.dropId === 'string' && map.dropId
      && typeof map.shippingWindow === 'string' && map.shippingWindow
      && map.currency === 'EUR' && map.variants
      && typeof map.variants === 'object' && !Array.isArray(map.variants));
  }
  function validEntry(entry) {
    return entry && typeof entry.variantId === 'string' && digits(entry.variantId)
      && typeof entry.sku === 'string' && entry.sku.length > 0
      && typeof entry.skuId === 'string' && entry.skuId.length > 0
      && typeof entry.color === 'string' && entry.color.length > 0
      && Array.isArray(entry.selectedOptions) && entry.selectedOptions.length === 2
      && entry.selectedOptions[0]?.name === 'Color' && entry.selectedOptions[0]?.value === entry.color
      && entry.selectedOptions[1]?.name === 'Version' && entry.selectedOptions[1]?.value === 'V4'
      && Number.isSafeInteger(entry.priceCents) && entry.priceCents > 0
      && Number.isSafeInteger(entry.quotaAtActivation) && entry.quotaAtActivation > 0;
  }
  function isPreorder(item) {
    return item && item.properties && item.properties._stl_preorder_hold === 'PREORDER_HOLD';
  }
  function isPeakLine(item) {
    return Boolean(item && !isPreorder(item)
      && ((item.properties && item.properties._sf_peak === '1') || item.vendor === PEAK_VENDOR));
  }
  /** Warenkorb darf nur Vorbestellungen desselben Drops und PEAK-Ware enthalten */
  function cartAllowsSet(cart, map) {
    return cart && cart.currency === 'EUR' && Array.isArray(cart.items)
      && cart.items.every(function (item) {
        return isPeakLine(item) || isPreorder(item) && String(item.product_id) === map.productId
          && item.properties._stl_drop_id === map.dropId;
      });
  }
  function matchesPreorderLine(item, map, entry) {
    return item && String(item.id) === entry.variantId && String(item.product_id) === map.productId
      && item.sku === entry.sku && isPreorder(item)
      && item.properties._stl_sku_id === entry.skuId && item.properties._stl_drop_id === map.dropId;
  }
  function productMatches(product, map, entry) {
    if (!product || String(product.id) !== map.productId || !Array.isArray(product.variants)) return false;
    var variant = product.variants.find(function (row) { return String(row.id) === entry.variantId; });
    return Boolean(variant && variant.available === true && variant.inventory_management === 'shopify'
      && variant.sku === entry.sku && variant.price === entry.priceCents
      && variant.option1 === entry.selectedOptions[0].value
      && variant.option2 === entry.selectedOptions[1].value && variant.option3 == null);
  }
  function getJson(url) {
    return window.fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('request_failed');
        return response.json();
      });
  }
  function userError(message) {
    var error = new Error(message);
    error.userMessage = message;
    return error;
  }

  class SFBundleSet extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      var cfgEl = this.querySelector('script[data-sfbs-config]');
      try { this.cfg = JSON.parse(cfgEl ? cfgEl.textContent : '{}'); } catch (e) { this.cfg = {}; }
      this.t = this.cfg.texts || {};
      this.stage = this.querySelector('[data-sfbs-stage]');
      var shaker = this.cfg.shaker || {};
      this.shakerVariants = (shaker.variants || []).filter(function (v) { return v && v.id; });
      this.wheys = (this.cfg.wheys || []).filter(function (w) { return w && w.variants && w.variants.length; });
      // Modus "order": Shaker als Vorbestellung, nur PEAK-Whey (versendet PEAK selbst). Sonst Hinweis-Modus.
      this.map = null;
      var peakWheys = this.wheys.filter(function (w) { return w.peak === true; });
      if (this.cfg.preorder && this.cfg.preorderOrder && this.cfg.preorderHandle && validMap(this.cfg.preorderMap) && peakWheys.length) {
        var map = this.map = this.cfg.preorderMap;
        this.wheys = peakWheys;
        this.shipDate = shipFrom(map.shippingWindow);
        this.shakerVariants.forEach(function (v) {
          var entry = map.variants[String(v.id)];
          v.pre = validEntry(entry) ? entry : null;
          v.available = !!v.pre;
          if (v.pre) v.price = v.pre.priceCents;
        });
      }
      // Vorbestellung: Farben nicht als ausverkauft zeigen, das Set ist nur noch nicht freigeschaltet (Button mit Datum)
      if (this.cfg.preorder && !this.map) this.shakerVariants.forEach(function (v) { v.available = true; });
      var section = this.closest('.sfbs');
      if (!this.stage || !this.shakerVariants.length || !this.wheys.length) {
        if (section) section.hidden = true;
        return;
      }
      if (section) section.hidden = false;
      this._ready = true;
      this.uid = 'sfbs' + (++uid);
      this.state = {
        shaker: this.firstAvailable(this.shakerVariants),
        whey: 0,
        flavor: null
      };
      this.state.flavor = this.firstAvailable(this.wheys[0].variants);
      this.render();
      this.update();
      if (this.map) this.refreshPreorder();
    }

    /* ------------------------------------------------ Daten */
    firstAvailable(list) {
      for (var i = 0; i < list.length; i++) if (list[i].available) return list[i].id;
      return list[0] ? list[0].id : null;
    }
    byId(list, id) {
      for (var i = 0; i < list.length; i++) if (String(list[i].id) === String(id)) return list[i];
      return null;
    }
    wheyIndex(handle) {
      for (var i = 0; i < this.wheys.length; i++) if (this.wheys[i].handle === handle) return i;
      return -1;
    }
    money(c) { return formatMoney(c, this.cfg.moneyFormat); }
    /** Umbruchschutz fuer Anzeigetexte (Konfigtexte bleiben unveraendert): Zahl und Einheit ("450 g",
        "15 Portionen", "3 Werktagen"), Datum ("ab 19. Oktober 2026") und "in 1 bis 3" bleiben zusammen. */
    nb(value) {
      return String(value || '')
        .replace(/(\d[\d.,]*)[ \t]+(?=\S)/g, '$1 ')
        .replace(/(^|\s)(ab|Ab|bis|Bis|in|je|von)[ \t]+(?=\d)/g, '$1$2 ')
        .replace(/(Januar|Februar|März|April|Mai|Juni|Juli|August|September|Oktober|November|Dezember)[ \t]+(?=\d{4})/g, '$1 ');
    }
    /** Namen ("Blue Raspberry", "Onyx Black") brechen nie in sich um */
    glue(value) { return String(value || '').replace(/ /g, ' '); }
    setCents(wheyPrice) {
      var d = Math.max(0, Math.min(90, Number(this.cfg.discount) || 0));
      return Math.round(wheyPrice * (100 - d) / 100);
    }
    get preorder() { return !!this.cfg.preorder; }
    /** Modus "order": Shaker wird als Vorbestellung gekauft */
    get preorderOrder() { return !!this.map; }
    /** Shaker-Preis im Set: im Modus "order" mit Vorbestellrabatt, abgerundet wie Shopify (1 Stueck) */
    shakerCents(s) {
      if (!this.preorderOrder) return s.price;
      var p = Math.max(0, Math.min(50, Number(this.cfg.preorderDiscount) || 0));
      return s.price - Math.floor(s.price * p / 100);
    }

    /** Kann das Set gerade gekauft werden (fuer den Protein-Rechner)? */
    get purchasable() {
      if (!this._ready || (this.preorder && !this.preorderOrder)) return false;
      var s = this.byId(this.shakerVariants, this.firstAvailable(this.shakerVariants));
      if (!s || !s.available) return false;
      for (var i = 0; i < this.wheys.length; i++) {
        var w = this.byId(this.wheys[i].variants, this.firstAvailable(this.wheys[i].variants));
        if (w && w.available) return true;
      }
      return false;
    }

    /** Setpreis fuer einen Whey (guenstigste lieferbare Kombination), als Text */
    priceFor(handle) {
      var idx = this.wheyIndex(handle);
      if (idx < 0 || !this._ready) return null;
      var s = this.byId(this.shakerVariants, this.firstAvailable(this.shakerVariants));
      var w = this.byId(this.wheys[idx].variants, this.firstAvailable(this.wheys[idx].variants));
      if (!s || !w) return null;
      var single = s.price + w.price;
      var set = this.shakerCents(s) + this.setCents(w.price);
      return { now: this.money(set), was: set < single ? this.money(single) : '', name: this.wheys[idx].name };
    }

    /** Whey vorwaehlen (aus dem Protein-Rechner) */
    preselect(handle) {
      var idx = this.wheyIndex(handle);
      if (idx < 0 || !this._ready) return;
      this.pickWhey(idx);
    }

    /* ------------------------------------------------ Aufbau */
    tpl(name) {
      var t = this.querySelector('template[data-sfbs-tpl="' + name + '"]');
      return t ? t.content.cloneNode(true) : document.createDocumentFragment();
    }

    radio(name, value, checked, disabled) {
      var input = el('input', 'sfbs-radio');
      input.type = 'radio';
      input.name = name;
      input.value = String(value);
      input.checked = !!checked;
      if (disabled) { input.disabled = true; input.setAttribute('data-soldout', ''); }
      return input;
    }

    render() {
      var self = this;
      var t = this.t;
      var shaker = this.cfg.shaker || {};
      this.stage.textContent = '';

      var grid = el('div', 'sfbs-grid');

      // Shaker
      var sCard = el('div', 'sfbs-card sfbs-card--shaker');
      var sMedia = el('div', 'sfbs-card__media');
      this.sImg = el('img', 'sfbs-card__img');
      this.sImg.alt = '';
      this.sImg.width = 280; this.sImg.height = 280;
      this.sImg.loading = 'lazy';
      sMedia.appendChild(this.sImg);
      var sBody = el('div', 'sfbs-card__body');
      sBody.appendChild(el('span', 'sfbs-label', t.shakerLabel));
      sBody.appendChild(el('h3', 'sfbs-card__title', shaker.title || 'STARKSHAKE'));
      this.sMeta = el('p', 'sfbs-card__meta');
      sBody.appendChild(this.sMeta);
      if (this.preorderOrder) {
        this.sShip = el('p', 'sfbs-card__ship sfbs-card__ship--preorder');
        sBody.appendChild(this.sShip);
      }
      var sSet = el('fieldset', 'sfbs-swatches');
      sSet.appendChild(el('legend', 'sfbs-sr', t.color));
      this.shakerVariants.forEach(function (v) {
        var lab = el('label', 'sfbs-swatch');
        lab.title = v.title + (v.available ? '' : ', ' + t.soldOut);
        var input = self.radio(self.uid + '-shaker', v.id, String(v.id) === String(self.state.shaker), !v.available);
        input.setAttribute('aria-label', v.title + (v.available ? '' : ', ' + t.soldOut));
        input.addEventListener('change', function () { self.state.shaker = v.id; self.update(); });
        lab.appendChild(input);
        var img = el('img', 'sfbs-swatch__img');
        img.alt = '';
        img.width = 48; img.height = 48;
        img.loading = 'lazy';
        if (v.thumb) img.src = v.thumb;
        lab.appendChild(img);
        sSet.appendChild(lab);
      });
      sCard.appendChild(sMedia);
      sCard.appendChild(sBody);
      var sOpts = el('div', 'sfbs-card__opts');
      sOpts.appendChild(sSet);
      var perks = this.tpl('perks');
      if (perks.querySelector && perks.querySelector('.sfbs-perk')) {
        [].forEach.call(perks.querySelectorAll('.sfbs-perk__title, .sfbs-perk__sub'), function (node) {
          node.textContent = self.nb(node.textContent);
        });
        sOpts.appendChild(perks);
      }
      sCard.appendChild(sOpts);

      // Plus
      var plus = el('div', 'sfbs-plus');
      plus.setAttribute('aria-hidden', 'true');
      plus.appendChild(this.tpl('plus'));

      // Whey
      var wCard = el('div', 'sfbs-card sfbs-card--whey');
      var wMedia = el('div', 'sfbs-card__media');
      this.wImg = el('img', 'sfbs-card__img');
      this.wImg.alt = '';
      this.wImg.width = 280; this.wImg.height = 280;
      this.wImg.loading = 'lazy';
      wMedia.appendChild(this.wImg);
      var wBody = el('div', 'sfbs-card__body');
      wBody.appendChild(el('span', 'sfbs-label', t.wheyLabel));
      this.wTitle = el('h3', 'sfbs-card__title');
      wBody.appendChild(this.wTitle);
      this.wMeta = el('p', 'sfbs-card__meta');
      wBody.appendChild(this.wMeta);
      if (this.preorderOrder) {
        this.wShip = el('p', 'sfbs-card__ship');
        wBody.appendChild(this.wShip);
      }
      if (this.wheys.length > 1) {
        var pSet = el('fieldset', 'sfbs-chips sfbs-chips--product');
        pSet.appendChild(el('legend', 'sfbs-sr', t.whey));
        this.wheys.forEach(function (w, i) {
          var lab = el('label', 'sfbs-chip');
          var input = self.radio(self.uid + '-whey', i, i === self.state.whey, false);
          input.addEventListener('change', function () { self.pickWhey(i); });
          lab.appendChild(input);
          lab.appendChild(el('span', 'sfbs-chip__text', w.name));
          pSet.appendChild(lab);
        });
        this.pSet = pSet;
      }
      this.fSet = el('fieldset', 'sfbs-chips sfbs-chips--flavor');
      wCard.appendChild(wMedia);
      wCard.appendChild(wBody);
      var wOpts = el('div', 'sfbs-card__opts');
      if (this.pSet) wOpts.appendChild(this.pSet);
      wOpts.appendChild(this.fSet);
      wCard.appendChild(wOpts);

      grid.appendChild(sCard);
      grid.appendChild(plus);
      grid.appendChild(wCard);

      // Summe: wie die Set-Karte des Protein-Rechners (Kacheln mit Glas-Plus, Titel, Preis, Siegel, Button unten)
      var sum = el('div', 'sfbs-sum');
      var intro = el('div', 'sfbs-sum__intro');
      intro.appendChild(el('span', 'sfbs-label', t.setLabel || 'Dein Set'));
      var sTop = el('div', 'sfbs-sum__top');
      var sPics = el('div', 'sfbs-sum__media');
      sPics.setAttribute('aria-hidden', 'true');
      var pic = function () {
        var box = el('span', 'sfbs-sum__pic');
        var img = el('img', 'sfbs-sum__img');
        img.alt = ''; img.width = 88; img.height = 88; img.loading = 'lazy';
        box.appendChild(img);
        return { box: box, img: img };
      };
      var tS = pic();
      var tW = pic();
      this.tShakerImg = tS.img;
      this.tWheyImg = tW.img;
      var tPlus = el('span', 'sfbs-sum__plus');
      tPlus.appendChild(this.tpl('plus'));
      sPics.appendChild(tS.box);
      sPics.appendChild(tPlus);
      sPics.appendChild(tW.box);
      var sHead = el('div', 'sfbs-sum__head');
      this.sumTitle = el('p', 'sfbs-sum__title');
      this.sumMeta = el('p', 'sfbs-sum__meta');
      sHead.appendChild(this.sumTitle);
      sHead.appendChild(this.sumMeta);
      sTop.appendChild(sPics);
      sTop.appendChild(sHead);
      // Preis-Aufstellung im Kaufblock: "Einzeln" mit Streichpreis, "Im Set" mit Spar-Etikett und Setpreis
      var bill = el('div', 'sfbs-bill');
      this.rowSingle = el('p', 'sfbs-bill__row sfbs-bill__row--single');
      this.rowSingle.appendChild(el('span', 'sfbs-bill__label', t.single || 'Einzeln'));
      this.pWas = el('s', 'sfbs-price__was');
      this.rowSingle.appendChild(this.pWas);
      var rowSet = el('p', 'sfbs-bill__row sfbs-bill__row--set');
      var setLabel = el('span', 'sfbs-bill__label');
      setLabel.appendChild(el('span', null, t.set || 'Im Set'));
      this.pSave = el('span', 'sfbs-price__save');
      setLabel.appendChild(this.pSave);
      this.pNow = el('strong', 'sfbs-price__now');
      rowSet.appendChild(setLabel);
      rowSet.appendChild(this.pNow);
      bill.appendChild(this.rowSingle);
      bill.appendChild(rowSet);
      var list = el('ul', 'sfbs-benefits');
      this.bShaker = el('li');
      this.bWhey = el('li');
      [this.bShaker, this.bWhey].forEach(function (li) {
        li.appendChild(self.tpl('seal'));
        li.appendChild(el('span'));
        list.appendChild(li);
      });
      this.cta = el('button', 'sfbs-cta', t.cta);
      this.cta.type = 'button';
      this.cta.addEventListener('click', this.add.bind(this));
      this.note = el('p', 'sfbs-note');
      this.note.setAttribute('role', 'status');
      this.note.setAttribute('aria-live', 'polite');
      intro.appendChild(sTop);
      // Eine Gruppe mit festen Abstaenden (Ueberzeile, Kacheln, Titel, Siegel); der einzige freie Raum
      // der Spalte liegt zwischen dieser Gruppe und dem Kaufblock.
      var main = el('div', 'sfbs-sum__main');
      main.appendChild(intro);
      main.appendChild(list);
      sum.appendChild(main);
      var buy = el('div', 'sfbs-sum__buy');
      buy.appendChild(bill);
      buy.appendChild(this.cta);
      if (this.preorderOrder && t.orderNote) buy.appendChild(el('p', 'sfbs-info', t.orderNote));
      buy.appendChild(this.note);
      sum.appendChild(buy);

      this.stage.appendChild(grid);
      this.stage.appendChild(sum);
      this.renderFlavors();
    }

    renderFlavors() {
      var self = this;
      var w = this.wheys[this.state.whey];
      this.fSet.textContent = '';
      this.fSet.appendChild(el('legend', 'sfbs-sr', this.t.flavor));
      var single = w.variants.length === 1;
      this.fSet.hidden = single;
      // Anzahl fuer das CSS: vier Sorten laufen 2 + 2, sechs Sorten 3 + 3 (nie eine Sorte allein in der Reihe)
      this.fSet.setAttribute('data-count', String(w.variants.length));
      w.variants.forEach(function (v) {
        var lab = el('label', 'sfbs-chip sfbs-chip--flavor');
        var input = self.radio(self.uid + '-flavor', v.id, String(v.id) === String(self.state.flavor), !v.available);
        input.addEventListener('change', function () { self.state.flavor = v.id; self.update(); });
        lab.appendChild(input);
        lab.appendChild(el('span', 'sfbs-chip__text', v.title));
        if (!v.available) lab.appendChild(el('span', 'sfbs-sr', ', ' + self.t.soldOut));
        self.fSet.appendChild(lab);
      });
    }

    pickWhey(i) {
      if (i === this.state.whey && this.state.flavor) { this.update(); return; }
      this.state.whey = i;
      this.state.flavor = this.firstAvailable(this.wheys[i].variants);
      if (this.pSet) {
        var inputs = this.pSet.querySelectorAll('input');
        for (var k = 0; k < inputs.length; k++) inputs[k].checked = Number(inputs[k].value) === i;
      }
      this.renderFlavors();
      this.update();
    }

    /* ------------------------------------------------ Zustand */
    update() {
      var t = this.t;
      var s = this.byId(this.shakerVariants, this.state.shaker);
      var w = this.wheys[this.state.whey];
      var f = this.byId(w.variants, this.state.flavor);
      if (s) {
        if (s.image) this.sImg.src = s.image;
        this.sMeta.textContent = s.title + (s.available ? '' : ', ' + t.soldOut);
      }
      this.wTitle.textContent = w.name;
      var metaParts = [];
      if (f && w.variants.length > 1) metaParts.push(this.glue(f.title) + (f.available ? '' : ', ' + t.soldOut));
      if (w.size) metaParts.push(this.nb(w.size));
      this.wMeta.textContent = metaParts.join(', ');
      var img = (f && f.image) || w.variants[0].image;
      if (img) this.wImg.src = img;
      // Summenkarte: Kacheln, Titel und Auswahl
      if (s && s.image) this.tShakerImg.src = s.image;
      if (img) this.tWheyImg.src = img;
      // Titel in zwei Teilen: "STARKSHAKE V4 +" bricht nie auseinander, keine Zeile beginnt mit "+"
      this.sumTitle.textContent = '';
      this.sumTitle.appendChild(el('span', 'sfbs-sum__t1', this.glue((this.cfg.shaker || {}).title || 'STARKSHAKE') + ' +'));
      this.sumTitle.appendChild(document.createTextNode(' '));
      this.sumTitle.appendChild(el('span', 'sfbs-sum__t2', w.name));
      var pick = [];
      if (s) pick.push(this.glue(s.title));
      if (f && w.variants.length > 1) pick.push(this.glue(f.title));
      this.sumMeta.textContent = pick.join(' · ');
      this.sumMeta.hidden = !pick.length;

      if (this.preorderOrder) {
        // Versandzeilen: Shaker aus dem Versandfenster der Vorbestell-Map, PEAK mit PEAKs eigener Angabe.
        // Quelle PEAK (geprueft 30.09.2026, peak.ag/products/clear-whey-isolate und /delicious-whey-protein):
        // "Verfügbar – In 1-3 Werktagen bei Dir (DE)", FAQ: "innerhalb von 1–3 Werktagen versendet".
        this.sShip.textContent = this.shipDate ? this.nb(fill(t.shipShaker, { d: this.shipDate })) : '';
        this.sShip.hidden = !this.shipDate;
        this.wShip.textContent = w.peak ? this.nb(t.shipPeak || '') : '';
        this.wShip.hidden = !(w.peak && t.shipPeak);
      }

      var single = (s ? s.price : 0) + (f ? f.price : 0);
      var set = (s ? this.shakerCents(s) : 0) + (f ? this.setCents(f.price) : 0);
      this.pNow.textContent = this.money(set);
      var saving = single - set;
      this.pWas.textContent = saving > 0 ? this.money(single) : '';
      this.pWas.hidden = !(saving > 0);
      this.rowSingle.hidden = !(saving > 0);
      this.pSave.textContent = saving > 0 ? fill(t.save, { s: this.money(saving) }) : '';
      this.pSave.hidden = !(saving > 0);

      this.bShaker.lastElementChild.textContent = this.nb((this.cfg.shaker || {}).fact || '');
      this.bShaker.hidden = !(this.cfg.shaker || {}).fact;
      this.bWhey.lastElementChild.textContent = this.nb(w.fact || '');
      this.bWhey.hidden = !w.fact;

      var ok = !!(s && s.available && f && f.available);
      var label = this.preorderOrder ? t.ctaPreorder : t.cta;
      // Fehlermeldung des letzten Versuchs bleibt stehen, bis die Auswahl sich aendert
      var msg = this._msg && this._msgKey === this.selectionKey() ? this._msg : '';
      if (this.preorder && !this.preorderOrder) {
        this.cta.textContent = this.cfg.preorderDate ? fill(t.preorder, { d: this.cfg.preorderDate }) : t.preorderSoon;
        this.cta.setAttribute('aria-disabled', 'true');
        this.note.textContent = '';
      } else if (!ok) {
        this.cta.textContent = label;
        this.cta.setAttribute('aria-disabled', 'true');
        this.note.textContent = msg || t.unavailable;
      } else if (!this._busy) {
        this.cta.textContent = label;
        this.cta.removeAttribute('aria-disabled');
        this.note.textContent = msg;
      }
    }
    selectionKey() { return this.state.shaker + ':' + this.state.flavor; }
    showError(message) {
      this._msg = message || this.t.error;
      this._msgKey = this.selectionKey();
    }

    /* ------------------------------------------------ Warenkorb (wie compact-product-bundle) */
    add(event) {
      if (event) event.preventDefault();
      if (this._busy || this.cta.hasAttribute('aria-disabled')) return;
      this._msg = '';
      if (this.preorderOrder) { this.addPreorder(); return; }
      var self = this;
      var w = this.wheys[this.state.whey];
      var props = { _sf_set: 'STARKSHAKE + ' + w.name };
      var wheyProps = { _sf_set: props._sf_set };
      // PEAK remains a neutral supplier line if the STARKSHAKE is removed later.
      // Keep separate properties so the regular STARKSHAKE is never marked as PEAK.
      if (w.peak === true) wheyProps._sf_peak = '1';
      var items = [
        { id: Number(this.state.shaker), quantity: 1, properties: props },
        { id: Number(this.state.flavor), quantity: 1, properties: wheyProps }
      ];
      var theme = window.theme || {};
      var routes = theme.routes || {};
      var addUrl = routes.cart_add_url ? routes.cart_add_url + '.js' : '/cart/add.js';
      if (/\.js\.js$/.test(addUrl)) addUrl = addUrl.slice(0, -3);
      var cartType = (theme.settings && theme.settings.cartType) || this.cfg.cartType;
      var drawer = document.querySelector('cart-drawer');
      var sections = [];
      if (drawer && cartType !== 'page') {
        document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sections } }));
      }
      this._busy = true;
      this.cta.setAttribute('aria-busy', 'true');
      this.cta.textContent = this.t.adding;
      this.note.textContent = '';
      fetch(addUrl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: items, sections: sections, sections_url: window.location.pathname })
      })
        .then(function (r) { return r.json(); })
        .then(function (state) {
          if (state && state.status) throw new Error(state.description || self.t.error);
          if (!drawer || cartType === 'page' || !theme.pubsub) {
            window.location.href = routes.cart_url || '/cart';
            return;
          }
          return fetch(routes.cart_url ? routes.cart_url + '.js' : '/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
            .then(function (r) { return r.json(); })
            .then(function (cart) {
              cart.sections = state.sections;
              theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'sf-bundle-set', cart: cart });
              document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: state } }));
              if (typeof drawer.show === 'function') drawer.show(self.cta);
            });
        })
        .catch(function (err) {
          self.note.textContent = (err && err.message) || self.t.error;
          self.showError(self.note.textContent);
        })
        .then(function () {
          self._busy = false;
          self.cta.removeAttribute('aria-busy');
          self.update();
        });
    }

    /* ------------------------------------------------ Vorbestellung als Set (Modus "order")
       Wie assets/stl-preorder-direct-cart.js: Vorbestellprodukt und Warenkorb frisch lesen, dann die
       Vorbestellzeile (Menge 1, gleiche Eigenschaften) plus PEAK-Whey (_sf_peak) in EINEM /cart/add.js,
       Rueckmeldung pruefen, bei unklarem Ausgang den Warenkorb lesen, dann Warenkorbseite. */
    refreshPreorder() {
      var self = this;
      var map = this.map;
      return getJson(localeRoot() + 'products/' + encodeURIComponent(this.cfg.preorderHandle) + '.js')
        .then(function (product) {
          var changed = false;
          self.shakerVariants.forEach(function (v) {
            var ok = !!(v.pre && productMatches(product, map, v.pre));
            if (v.available !== ok) { v.available = ok; changed = true; self.markSwatch(v); }
          });
          if (!changed) return;
          var cur = self.byId(self.shakerVariants, self.state.shaker);
          if ((!cur || !cur.available) && !self._busy) {
            self.state.shaker = self.firstAvailable(self.shakerVariants);
            var input = self.swatchInput(self.state.shaker);
            if (input) input.checked = true;
          }
          self.update();
        })
        .catch(function () { /* Pruefung beim Klick bleibt massgeblich */ });
    }
    swatchInput(id) {
      var inputs = this.stage.querySelectorAll('input[name="' + this.uid + '-shaker"]');
      for (var i = 0; i < inputs.length; i++) if (inputs[i].value === String(id)) return inputs[i];
      return null;
    }
    markSwatch(v) {
      var input = this.swatchInput(v.id);
      if (!input) return;
      var label = v.title + (v.available ? '' : ', ' + this.t.soldOut);
      input.disabled = !v.available;
      if (v.available) input.removeAttribute('data-soldout'); else input.setAttribute('data-soldout', '');
      input.setAttribute('aria-label', label);
      if (input.parentNode) input.parentNode.title = label;
    }

    addPreorder() {
      var self = this;
      var t = this.t;
      var map = this.map;
      var s = this.byId(this.shakerVariants, this.state.shaker);
      var w = this.wheys[this.state.whey];
      var f = this.byId(w.variants, this.state.flavor);
      var entry = s && s.pre;
      if (!entry || !f || !w.peak) return;
      var root = localeRoot();
      var items = [
        { id: Number(entry.variantId), quantity: 1, properties: {
          _stl_drop_id: map.dropId,
          _stl_sku_id: entry.skuId,
          _stl_preorder_hold: 'PREORDER_HOLD',
          Vorbestellung: 'Zahlung sofort',
          Versandfenster: readableShippingWindow(map.shippingWindow),
        } },
        { id: Number(f.id), quantity: 1, properties: { _sf_peak: '1', _sf_set: 'STARKSHAKE + ' + w.name } }
      ];
      var isWhey = function (line) {
        return line && String(line.id) === String(f.id) && line.properties && line.properties._sf_peak === '1';
      };
      var confirmed = function (lines) {
        var pre = (lines || []).filter(function (line) { return matchesPreorderLine(line, map, entry); });
        return pre.length === 1 && pre[0].quantity === 1 && (lines || []).some(isWhey);
      };
      var done = false;
      var added = false;
      this._busy = true;
      this._msg = '';
      this.cta.setAttribute('aria-busy', 'true');
      this.cta.textContent = t.adding;
      this.note.textContent = '';
      Promise.all([
        getJson(root + 'products/' + encodeURIComponent(this.cfg.preorderHandle) + '.js'),
        getJson(root + 'cart.js')
      ])
        .then(function (results) {
          if (!productMatches(results[0], map, entry)) {
            s.available = false;
            self.markSwatch(s);
            throw userError(t.preSoldOut);
          }
          if (!cartAllowsSet(results[1], map)) throw userError(t.preMixed);
          if (results[1].items.some(function (line) { return matchesPreorderLine(line, map, entry); })) throw userError(t.preInCart);
          added = true;
          return window.fetch(root + 'cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ items: items })
          })
            .then(function (response) {
              if (!response.ok) throw new Error('cart_add_failed');
              return response.json();
            })
            .then(function (result) {
              if (!confirmed(result && result.items)) throw new Error('cart_readback_failed');
            })
            .catch(function () {
              // Unklarer Ausgang: erst den Warenkorb lesen, damit nichts doppelt hineinkommt
              return getJson(root + 'cart.js').then(function (cart) {
                if (!cart || !confirmed(cart.items)) throw userError(t.preUnconfirmed);
              }, function () { throw userError(t.preUnconfirmed); });
            });
        })
        .then(function () {
          done = true;
          window.location.assign(root + 'cart');
        })
        .catch(function (err) {
          self.showError((err && err.userMessage) || (added ? t.preUnconfirmed : t.error));
        })
        .then(function () {
          if (done) return;
          self._busy = false;
          self.cta.removeAttribute('aria-busy');
          self.update();
        });
    }
  }

  customElements.define('sf-bundle-set', SFBundleSet);
})();
